import styled, { css } from 'styled-components';
import { colors } from '../theme/colors';
import { spacing } from '../theme/spacing';
import { typography } from '../theme/typography';

export const formSizeStyles = {
  xs: css`
    padding: ${props => props.theme.spacing.xs} 0;
    font-size: ${props => props.theme.typography.fontSize.xs};
  `,
  sm: css`
    padding: calc(${props => props.theme.spacing.xs} * 1.5) 0;
    font-size: ${props => props.theme.typography.fontSize.sm};
  `,
  md: css`
    padding: ${props => props.theme.spacing.sm} 0;
    font-size: ${props => props.theme.typography.fontSize.md};
  `,
  lg: css`
    padding: ${props => props.theme.spacing.md} 0;
    font-size: ${props => props.theme.typography.fontSize.lg};
  `,
};

export const formSelectSizeStyles = {
  xs: css`
    padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.fontSize.xs};
  `,
  sm: css`
    padding: calc(${props => props.theme.spacing.xs} * 1.5) ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.fontSize.sm};
  `,
  md: css`
    padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.fontSize.md};
  `,
  lg: css`
    padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.fontSize.lg};
  `,
  xl: css`
    padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.fontSize.xl};
  `,
};

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: ${props => props.theme.typography.fontFamily.base};
`;

export const FormLabel = styled.label`
  font-size: ${props => props.theme.typography.fontSize.sm};
  color: ${props => props.theme.colors.brand.primary};
  margin-bottom: 4px;
  font-weight: 600;
  ${(props) => props.disabled && `color: ${props => props.theme.colors.text.muted};`}
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  opacity: ${props => props.disabled ? 0.6 : 1};
`;

export const FormError = styled.span`
  color: ${props => props.theme.colors.feedback.error};
  font-size: ${props => props.theme.typography.fontSize.xs};
  margin-top: 4px;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/sharedFormStyles.js